import { render, staticRenderFns } from "./SupplierStatusPage.vue?vue&type=template&id=061052ba&scoped=true"
import script from "./SupplierStatusPage.vue?vue&type=script&lang=js"
export * from "./SupplierStatusPage.vue?vue&type=script&lang=js"
import style0 from "./SupplierStatusPage.vue?vue&type=style&index=0&id=061052ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061052ba",
  null
  
)

export default component.exports